/**
 * API endpoints for the admin panel services
 */
export const ENDPOINTS = {
  // Authentication
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  REFRESH_TOKEN: "/auth/refresh-token",
  FORGOT_PASSWORD: "/auth/forgot-password",
  VERIFY_OTP: "/auth/verify-otp",
  RESET_PASSWORD: "/auth/reset-password",
  CHANGE_PASSWORD: "/auth/change-password",

  // User Management
  GET_USERS: "/users/list",
  GET_USER_BY_ID: "/users/:id",
  CREATE_USER: "/users",
  UPDATE_USER: "/users/:id",
  DELETE_USER: "/users/:id",
  SOFT_DELETE_USER: "/users/:id/delete",

  // User Logs
  GET_USER_LOGS: "/users/logs",

  // Dashboard
  GET_DASHBOARD_DATA: "/users/dashboard",
  GET_DASHBOARD_USER_STATS: "/users/dashboard/user-stats",
  GET_DASHBOARD_SCAN_STATS: "/users/dashboard/scan-stats",
  GET_DASHBOARD_TOP_FARMERS: "/users/dashboard/top-farmers",
  GET_DASHBOARD_RECENT_UPLOADS: "/users/dashboard/recent-uploads",

  // Settings / Profile
  UNIFIED_UPDATE: "/auth/unified-update",

  // Notifications
  GET_NOTIFICATIONS: "/users/notifications",
  MARK_NOTIFICATIONS_SEEN: "/users/notifications/mark-seen",
  CLEAR_NOTIFICATIONS: "/users/notifications/clear",

  // Grading
  GET_GRADING_BY_ID: "/grading",
  GET_USER_GRADING_HISTORY: "/grading/history",
  GET_USER_GRADING_HISTORY_ADMIN: "/grading/admin/user-history",

  // File Upload
  GENERATE_PRESIGNED_URL: "/file/generate-presigned-url",
  DELETE_FILE: "/file/delete-file",

  // Search
  SEARCH: "/search",
} as const;
